import _toConsumableArray from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var _Plugins_engine;

export var Plugins = /*#__PURE__*/function () {
  function Plugins(engine) {
    _classCallCheck(this, Plugins);

    _Plugins_engine.set(this, void 0);

    __classPrivateFieldSet(this, _Plugins_engine, engine, "f");

    this.plugins = [];
    this.interactorsInitializers = new Map();
    this.moversInitializers = new Map();
    this.updatersInitializers = new Map();
    this.interactors = new Map();
    this.movers = new Map();
    this.updaters = new Map();
    this.presets = new Map();
    this.drawers = new Map();
    this.pathGenerators = new Map();
  }

  _createClass(Plugins, [{
    key: "addInteractor",
    value: function addInteractor(name, initInteractor) {
      this.interactorsInitializers.set(name, initInteractor);
    }
  }, {
    key: "addParticleMover",
    value: function addParticleMover(name, initMover) {
      this.moversInitializers.set(name, initMover);
    }
  }, {
    key: "addParticleUpdater",
    value: function addParticleUpdater(name, initUpdater) {
      this.updatersInitializers.set(name, initUpdater);
    }
  }, {
    key: "addPathGenerator",
    value: function addPathGenerator(type, pathGenerator) {
      if (!this.getPathGenerator(type)) {
        this.pathGenerators.set(type, pathGenerator);
      }
    }
  }, {
    key: "addPlugin",
    value: function addPlugin(plugin) {
      if (!this.getPlugin(plugin.id)) {
        this.plugins.push(plugin);
      }
    }
  }, {
    key: "addPreset",
    value: function addPreset(presetKey, options) {
      var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (override || !this.getPreset(presetKey)) {
        this.presets.set(presetKey, options);
      }
    }
  }, {
    key: "addShapeDrawer",
    value: function addShapeDrawer(type, drawer) {
      if (!this.getShapeDrawer(type)) {
        this.drawers.set(type, drawer);
      }
    }
  }, {
    key: "destroy",
    value: function destroy(container) {
      this.updaters.delete(container);
      this.movers.delete(container);
      this.interactors.delete(container);
    }
  }, {
    key: "getAvailablePlugins",
    value: function getAvailablePlugins(container) {
      var res = new Map();

      var _iterator = _createForOfIteratorHelper(this.plugins),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var plugin = _step.value;

          if (!plugin.needsPlugin(container.actualOptions)) {
            continue;
          }

          res.set(plugin.id, plugin.getPlugin(container));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return res;
    }
  }, {
    key: "getInteractors",
    value: function getInteractors(container) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var res = this.interactors.get(container);

      if (!res || force) {
        res = _toConsumableArray(this.interactorsInitializers.values()).map(function (t) {
          return t(container);
        });
        this.interactors.set(container, res);
      }

      return res;
    }
  }, {
    key: "getMovers",
    value: function getMovers(container) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var res = this.movers.get(container);

      if (!res || force) {
        res = _toConsumableArray(this.moversInitializers.values()).map(function (t) {
          return t(container);
        });
        this.movers.set(container, res);
      }

      return res;
    }
  }, {
    key: "getPathGenerator",
    value: function getPathGenerator(type) {
      return this.pathGenerators.get(type);
    }
  }, {
    key: "getPlugin",
    value: function getPlugin(plugin) {
      return this.plugins.find(function (t) {
        return t.id === plugin;
      });
    }
  }, {
    key: "getPreset",
    value: function getPreset(preset) {
      return this.presets.get(preset);
    }
  }, {
    key: "getShapeDrawer",
    value: function getShapeDrawer(type) {
      return this.drawers.get(type);
    }
  }, {
    key: "getSupportedShapes",
    value: function getSupportedShapes() {
      return this.drawers.keys();
    }
  }, {
    key: "getUpdaters",
    value: function getUpdaters(container) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var res = this.updaters.get(container);

      if (!res || force) {
        res = _toConsumableArray(this.updatersInitializers.values()).map(function (t) {
          return t(container);
        });
        this.updaters.set(container, res);
      }

      return res;
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options, sourceOptions) {
      var _iterator2 = _createForOfIteratorHelper(this.plugins),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var plugin = _step2.value;
          plugin.loadOptions(options, sourceOptions);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "loadParticlesOptions",
    value: function loadParticlesOptions(container, options) {
      var updaters = this.updaters.get(container);

      if (!updaters) {
        return;
      }

      for (var _len = arguments.length, sourceOptions = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        sourceOptions[_key - 2] = arguments[_key];
      }

      var _iterator3 = _createForOfIteratorHelper(updaters),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var updater = _step3.value;

          if (updater.loadOptions) {
            updater.loadOptions.apply(updater, [options].concat(sourceOptions));
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }]);

  return Plugins;
}();
_Plugins_engine = new WeakMap();